import React from 'react';
import Helmet from "react-helmet/es/Helmet";
import {DateTime} from 'luxon';
import NumberFormat from 'react-number-format';
import SummaryChargesDesktop from '../summary-charges-details/SummaryChargesDesktop';
import { useEffectMobileSummaryCharges } from '../useEffect/useEffectMobileSummaryCharges';
import SummaryChargesMobile from '../summary-charges-details/SummaryChargesMobile';

class ConfirmationDetails extends React.Component {

    constructor(props) {
        super(props);
        this.booking = this.props.booking;
        this.franchiseData = this.props.franchiseData;
        this.siteConfigData = this.props.siteConfigData;
        this.onChangeView = this.props.onChangeView;
        this.makePaymentResponse = this.props.makePaymentResponse;

        this.state = {
			isLoading: true,
			charges: {},
			contentId: 'expandCollapseCont',
   			isExpanded: true,
        	showConfirmationPopup: false,
            termesAndConditionsAccepted: false,
            confirmView: {"bookingSummary":{
                "add-ons":[
                    
                    ],
                    "returnDate":"",
                    "charges":{
                       "insurance":{
                          "include":false
                       },
                       "paymentDueDate":"",
                       "balanceIncludeFuturePayments":0,
                       "balanceExcludeFuturePayments":0,
                       "scheduledPayment":0,
                       "paymentsToDate":0,
                       "lastScheduledPayment":"",
                       "remainingBalance":0,
                       "totalCost":"0"
                    }
                    
                    
                    
                 }
              },
            
        }

        window.dataLayer = window.dataLayer || [];
        try {
			var oneTrust = window.OnetrustActiveGroups;
			if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust && oneTrust.includes('C0004')) {
				window.dataLayer.push({
					'event': 'VirtualPageview',
					'virtualPageURL': 'gaVirtualPageURL',
					'virtualPagePath': '/css/guest/confirmation',
					'virtualPageTitle': 'Customer Self Service'
	
				});
			} else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
				window.dataLayer.push({
					'event': 'VirtualPageview',
					'virtualPageURL': 'gaVirtualPageURL',
					'virtualPagePath': '/css/guest/confirmation',
					'virtualPageTitle': 'Customer Self Service'
	
				});
			} else {
				console.log("off");    
			}
       
        } catch (error) {
            //swallow error
        }
    }

	toggleExpand = () => {
		this.setState((prevState) => ({
			isExpanded: !prevState.isExpanded
		}));
	}
	
	handleKeyDownSummaryCharges = (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			this.toggleExpand();
		}
	}

    checkNewPaymentWarning = () => {
    	if(this.state.newFuturePayments===true){
        	//this.setState({warningClass: 'warningMessageHeaderConfirmation'});
        }
    }
    
    getStoreAttValue = (attCode) => {
    	let storeAttributeValue='';
    	for(let i=0; i<this.props.siteConfigData.store.storeAttributes.length; i++){
    		if(this.props.siteConfigData.store.storeAttributes[i].attributeCode===attCode){
    			storeAttributeValue = this.props.siteConfigData.store.storeAttributes[i].attributeValue;
    		}
    	}
    	return storeAttributeValue;
    }
    
    getTemplatePropertyValue = (propertyName) => {
    	let templatePropertyValue='';
    	for(let j=0; j<this.props.siteConfigData.templateProperties.length; j++){
    		if(this.props.siteConfigData.templateProperties[j].propertyName===propertyName){
    			templatePropertyValue = this.props.siteConfigData.templateProperties[j].propertyValue;
    		}
    	}
    	return templatePropertyValue;
    }
    
    getSitePropertyValue = (propertyName) => {
    	let sitePropertyValue='';
    	for(let k=0; k<this.props.siteConfigData.siteProperties.length; k++){
    		if(this.props.siteConfigData.siteProperties[k].propertyName===propertyName){
    			sitePropertyValue = this.props.siteConfigData.siteProperties[k].propertyValue;
    		}
    	}
    	return sitePropertyValue;
    }
    getFormattedDate = (dateToFormat) => {
    	let formattedDate = DateTime.fromISO(dateToFormat).toLocaleString(DateTime.DATE_FULL);
    	return formattedDate;
    }
    
    /* Spinner for Ajax calls */
    ajaxSpinnerShow = () => {
    	 document.getElementById("ajaxLoadText").innerHTML = "loading";
    	 document.getElementById("ajaxShim").style.display = "block";
    	 document.getElementById("ajaxSpinnerOuter").style.display = "block";
    	 document.getElementById("ajaxSpinner").style.display = "block";
     }	
     
     ajaxSpinnerHide = () => {
    	 document.getElementById("ajaxSpinner").style.display = "none";
    	 document.getElementById("ajaxSpinnerOuter").style.display = "none";
    	 document.getElementById("ajaxShim").style.display = "none";
     }
    
	isMobileOrDesktop = () => useEffectMobileSummaryCharges();

    componentDidMount = () => {
        window.scrollTo(0, 0);
        this.getBookingAgain();
    }

    getBookingAgain = () => {
    	console.debug('getting booking...');
        let url = '/wthrest/customer-self-service/getBooking.rs';
        let payload = {
            "bookingNumber": localStorage.getItem("confirmationNumber"),
            "hash": this.props.hash
        }
        this.ajaxSpinnerShow();
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(bookingResponse => bookingResponse.json()).then(jsonBookingResponse => { 
			if(jsonBookingResponse.success) {
                //eslint-disable-next-line       	
	        	if(jsonBookingResponse.futurePayments!==null&&jsonBookingResponse.futurePayments!=''){
	        		for(let i = 0; i <jsonBookingResponse.futurePayments.length; i++) {
						//eslint-disable-next-line
	        			if(jsonBookingResponse.futurePayments[i].newFuturePayment==true) {							
	        				this.setState({newFuturePayments: true});
	        		    
	    				}
	        		}
	
	    			if(this.state.newFuturePayments===true){
	    				this.props.CallTracker("Customer Self Service", "Page Alert", "Today's payment(or a portion of the payment) will be processed on the next business day, and is shown as a new scheduled payment.  Your Remaining Balance will be updated once your payment is processed.");
	    			}
	    		}
	        	this.ajaxSpinnerHide();
	        	this.setState({confirmView: jsonBookingResponse});
				this.setState({
					charges: {
						pageId: 'confirmation',
						totalcost: this.state.confirmView.bookingSummary.charges.totalCost,
						insuranceStatus: this.state.confirmView.bookingSummary.charges.insurance.include ? 'Included' : 'Declined',
						paymentToDate: localStorage.getItem('previousPayments'),
						todaysPayment: this.props.makePaymentResponse.paymentAmount,
						remainingBalance: this.state.confirmView.bookingSummary.charges.balanceExcludeFuturePayments > 0 && this.state.confirmView.bookingSummary.charges.balanceExcludeFuturePayments,
						chargesPaymentDueDate: this.props.makePaymentResponse.paymentDueDate,
						futurePayments: this.state.confirmView.futurePayments,
						scheduledPayment: jsonBookingResponse.bookingSummary.charges.scheduledPayment,
						scheduledPaymentHasChanged: localStorage.getItem("scheduledPaymentHasChanged")==='true',
						newFuturePayments: this.state.newFuturePayments===true,
						paidInFullLanguage: this.state.confirmView.bookingSummary.charges.balanceExcludeFuturePayments === 0.00 && 'Paid In Full'
					},
				});
				this.setState({
					isLoading: false
				})
	        	return jsonBookingResponse;
			} else {
				this.ajaxSpinnerHide();
	            this.props.onChangeView('verification');
			}        	
        }).catch(error => {
        	this.ajaxSpinnerHide();
        	console.log("get booking failed");
            //TODO set error
        	return null;
        });
    }
    
    render = () => {
        this.checkNewPaymentWarning();
		const { charges, isLoading } = this.state;
		if (isLoading) return <></>;
        return (
			<div id="confirmationPageMain" className={`wth3-cssMainContent ${this.props.makePaymentResponse.paymentStatus===false ? 'wth3-successPage-error' : ''}`}>
				<div className='wth3-cssMainContent__leftCont'>
					<div className='wth3-cssMainContent__leftCont-topContent' id="mainContent" tabindex="-1">

						<Helmet>
							<title>Customer Self Service / Confirmation</title>
						</Helmet>

						<button class="wth3-returnButton" id="css_tripTools" onClick={e =>{e.preventDefault();this.props.onChangeView('summary-swap', this.booking, this.booking.hash, this.state.updatedBooking)} }>
							<i class="fas fa-home" aria-hidden='true'></i>Return to Booking Summary
						</button>

						<div className='wth3-cssMainContent__leftCont-topContent-pageTitleCont'>
							<h1 id='css_title_visible' className='wth3-cssMainContent__leftCont-topContent-pageTitleCont-text'>Payment Confirmation</h1>
						</div>

						{this.props.makePaymentResponse.paymentStatus===true &&	
							<SummaryChargesMobile toggleExpand={this.toggleExpand} handleKeyDownSummaryCharges={this.handleKeyDownSummaryCharges} charges={charges} isExpanded={this.state.isExpanded} contentId={this.state.contentId} isMobileOrDesktop={this.isMobileOrDesktop} />		
						}
						
						{this.props.makePaymentResponse.paymentStatus===false &&
						<div id="paymentContents">
							<div id="message5" class="wth2-errorMessage wth2-errorMessageHeader">
								<i class="fa fa-exclamation-circle" aria-hidden="true"></i> We&#39;re sorry. We are unable to process your payment. Please try your request again or call {this.props.siteConfigData.cruisePhone} and speak to a cruise expert who will be happy to assist you. Cruise experts are available {this.props.siteConfigData.operationHrs}.  
							</div>
						</div>
						}
						{this.props.makePaymentResponse.paymentStatus===true &&
						<div id="paymentContents">
							<div id="message2" class="wth3-cssMainContent__leftCont-topContent-successCont">
								<div className='wth3-cssMainContent__leftCont-topContent-successCont-thankyouTitle'>Thank you for your payment!</div>
								<div className='wth3-cssMainContent__leftCont-topContent-successCont-text'>This payment will be credited to your account within one business day. <br /> Your updated summary of charges reflect your current payment.</div>
								<div class="wth3-cssMainContent__leftCont-topContent-successCont-thankyou" id="message2Cont">
									<span class=" wth2-sucessMessageHeader">Your payment of <NumberFormat value={this.props.makePaymentResponse.paymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /> was successful</span>
								</div>
							</div>
						</div>
						}
						
					</div>
				</div>
				{this.props.makePaymentResponse.paymentStatus===true &&
					<SummaryChargesDesktop charges={charges} isExpanded={this.state.isExpanded} contentId={this.state.contentId} />
				}
				
			</div>
	            
        );
    }

   
}

export default ConfirmationDetails;
